import React, { useEffect, useState } from "react";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import AddUpdModal from "./AddUpdModal";
import PreviewPDF from "../../../helpers/previewPDF";
import { getConfigurations, getRouteConfigs, resourcesConfigurationRoute, resourcesFuelSales } from "../../../helpers/backend_helper";
import { DestroyAlertHelper, Alert } from "../../../helpers/alerts/alertHelper";
import { getStorageUser } from "../../../helpers/api_helper";
import { Button, Container } from "reactstrap";
import ButtonHelper from "../../../helpers/ButtonHelper";
import FilesListHelper from "../../../helpers/FilesListHelper";
import * as dayjs from "dayjs";
import PriceModal from "./PriceModal";

const FuelSales = () => {
  let timeElapsed = new Date();
  let dateNow = dayjs().format("YYYY-MM-DD");
  const [date, setDate] = useState({ initDate: "", endDate: "" });
  const authUser = getStorageUser();
  const [pending, setPending] = useState(false);
  const [price, setPrice] = useState(null);
  const [modal, setModal] = useState({ show: false, update: false });
  const [modalFile, setModalFile] = useState({
    show: false,
    id: null,
    files: [],
  });

  const [modalPdf, setModalPdf] = useState({ show: false, update: false });
  const [modalPrice, setModalPrice] = useState({ show: false, update: false });
  const [modalObserv, setModalObserv] = useState({
    show: false,
    type: 1,
    id: null,
  });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
    companySession: authUser.company_id,
    initDate: dateNow,
  });
  const [items, setItems] = useState([]);
  const itemBase = {
    id: null,
    date: dateNow,
    time: "",
    unit_price: null,
    amount: null,
    total: 0,
    operator_id: null,
    operator: [],
    unit_id: null,
    unit: [],
    seller_id: null,
  };
  const [item, setItem] = useState(itemBase);

  useEffect(() => {
    let params = { params: filters };
    setPending(true);
    resourcesFuelSales("get", params).then((response) => {
      setItems(response.data);
      setDataPag(response.meta);
      setPending(false);
    });
  }, [filters]);

  const addUpd = (row) => {
    if (row.id) {
      setItem(row);
      setModal({ ...modal, show: true, update: true });
    } else {
      setItem({ ...itemBase, time: dayjs().format("HH:mm") });
      setModal({ ...modal, show: true, update: false });
    }
  };

  const destroy = (id) => {
    DestroyAlertHelper(async (confirmed) => {
      if (!confirmed) {
        return;
      }
      resourcesFuelSales("del", id, id).then((response) => {
        Alert(response.message, response.status);
        if (response.status) {
          setItems(items.filter((i) => i.id != id));
        }
      });
    });
  };

  const getReports = (type) => {
    let config = {
      params: filters,
      headers: {
        Accept:
          type == 2
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    };
    resourcesFuelSales("get", config).then((response) => {
      if (type == 1) {
        const url = URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Venta de Combustibles.xlsx");
        document.body.appendChild(link);
        link.click();
      } else {
        let nombre = "Archivo";
        var reader = new FileReader();
        reader.readAsDataURL(response);
        reader.fileName = nombre[1] || nombre[0];
        reader.onloadend = function (name) {
          name = nombre[0];
          var base64data = reader.result;
          setModalPdf({ show: true, update: false, url: base64data });
        };
      }
    });
  };

  useEffect(() => {
    const fetchConfigs = async () => {
      const response = await getRouteConfigs();
      const priceConfig = response.filter(e => e.configuration_id == 14) 
      console.log(priceConfig[0]?.value ?? 0)
      setPrice(priceConfig[0]?.value ?? 0)
    }

    fetchConfigs()
  }, []);

  const columns = Columns(addUpd, destroy, setModalFile, modalFile);
  document.title = "Venta de Combustibles | Sistema de logística";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              filterInp={false}
              tittle="Venta de Combustibles"
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
            >
              <div className="mb-3">
                <ButtonHelper
                  actionSave={addUpd}
                  addButon={
                    authUser.profile_id == 2 || authUser.profile_id == 3
                  }
                  reportButons={true}
                  actionReportButon={getReports}
                  actionAddButon={() => addUpd(item)}
                >
                  <Button
                    className="btn-sm float-end me-2"
                    type="button"
                    value={"Config"}
                    onClick={(e) =>
                      setModalPrice({ ...modalPrice, show: true })
                    }
                  >
                    <i className="fa fa-coins"></i> Precio
                  </Button>
                </ButtonHelper>
              </div>
              <div className="col-sm-2">
                <label className="form-label">Fecha:</label>
                <input
                  className="form-control"
                  placeholder="Fecha"
                  name="time"
                  type="date"
                  onChange={(e) =>
                    setFilters({ ...filters, initDate: e.target.value })
                  }
                  value={filters.initDate}
                />
              </div>
            </DataTableHelper>
          </div>
        </Container>
        {modal.show && (
          <AddUpdModal
            modal={modal}
            setModal={setModal}
            items={items}
            setItems={setItems}
            item={item}
            setItem={setItem}
            authUser={authUser}
            price={price}
          />
        )}
        {modalPdf.show && (
          <PreviewPDF modalPdf={modalPdf} setModalPdf={setModalPdf} />
        )}
        {modalPrice.show && price != null && (
          <PriceModal modal={modalPrice} setModal={setModalPrice} price={price} setPrice={setPrice} />
        )}
        {console.log(modalFile.show)}
        {modalFile.show && (
          <FilesListHelper
            modal={modalFile}
            setModal={setModalFile}
            title="Archivos de Ventas"
            type="sale"
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default FuelSales;
